import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import {
  defaultTellingen,
  type EnvironmentSettings,
  type LinkItem,
} from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Aanvragen, {
  isVisible: (settings: EnvironmentSettings) =>
    settings.isActiveAdviseur || settings.isInterneGebruiker,
  create: (settings: EnvironmentSettings): LinkItem => {
    const tellingen = settings.tellingen ?? defaultTellingen;

    return {
      itemtype: 'link',
      menuItem: MenuItems.Aanvragen,
      title: 'Aanvragen',
      url: '/app/aanvraag/recente-activiteiten/aanvragen',
      iconclass: 'far fa-calculator',
      showbadge: !!tellingen.aantalAanvragen,
      badgecontent: tellingen.aantalAanvragen,
      target: '_top',
    };
  },
});
